import * as styles from "./PopoverTitle.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { Popover as BasePopover } from "@base-ui/react/popover";

import type { PopoverTitleProps } from "./Popover.types";

export function PopoverTitle({
  className,
  ...props
}: PopoverTitleProps): JSX.Element {
  return (
    <BasePopover.Title
      data-slot="popover-title"
      className={clsx(styles.title, className)}
      {...props}
    />
  );
}
